export enum BeneficiarySourceEnum {
  listing = 1,  // It's called from the 'Manage Beneficiaries' listing screen
  payment = 2   // It's called from the 'Send Payment Instruction' or 'Fund Your Account' tiles on the dashboard
}
